// initial state
const state = () => ({
  locations: [],
});

// getters
const getters = {
  getLocations: state => {
    return state.locations;
  },
};

// actions
const actions = {
  load({ commit, getters }) {
    if (getters.getLocations.length > 0) {
      return Promise.resolve();
    }

    return axios.get(zRoute('ajax.locations.search')).then(function (response) {
      commit('setLocations', response.data.data);
    }, function (error) {
      //
    });
  },
};

// mutations
const mutations = {
  setLocations: (state, locations) => {
    state.locations = locations;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
